<template>
  <div class="storeSuccess bgwhite">
    <div class="paySuccess">
      <div class="paySuccessImg">
        <img src="../../assets/wxRenew/pay-success.gif">
      </div>
      <div class="storeSuccess-success-msg">
        <span v-if="handoverType === 'store'">提交收到入库成功</span>
        <span v-else-if="handoverType === 'return'">提交归还客户成功</span>
      </div>
      <div>
        <div>
          <van-row class="btnRow">
            <van-col span="12" class="centerText" @click.native="goBack">返回资料交接</van-col>
            <van-col span="12" class="centerText confirmText" @click.native="linkSkip('storeSignature',{id: id, customerId: customerId, transferName: transferName},'','')">点击进入客户签名</van-col>
          </van-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Row, Col, Icon } from "vant";
Vue.use(Row)
  .use(Col)
  .use(Icon)

export default {
  name: "storeSuccess",
  components: {},
  data() {
    return {
      timer: 3, // 倒计时3秒
      id: '', // 单据id
      customerId: '',
      handoverType: '', // 交接类型：store收到入库；return归还客户；interior内部移交
      transferName: ''
    };
  },

  methods: {
    goBack () {
      this.$router.go(-3);
    },
    linkSkip (name, params) {
      this.$router.push({
        name: name,
        params: params
      });
    }
  },
  mounted: function() {
    let params = this.$route.query
    this.handoverType = params.handoverType
    this.id = params.id
    this.customerId = params.customerId
    this.transferName = params.transferName
  }
};
</script>

<style type="text/css" lang="stylus" scoped>
.storeSuccess.bgwhite{
  background-color #ffffff;
  height  100%;
  padding-bottom 0;
}
.storeSuccess {
  position: relative;
  padding-bottom 0.5rem

  .paySuccess {
    text-align center
    .paySuccessImg{
      padding-top: 1.68rem;
      img{
        width 0.88rem
      }
    }
    .storeSuccess-success-msg{
      font-size: 0.24rem;
      margin-top: 0.08rem;
      font-weight: bold;
      color #1A2633
    }
    .btnRow {
        text-align: center;
        color: #1FADF6;
        background-color: #ffffff;
        border-top: 1px solid #f0f2f2;
        position: fixed;
        width: 100%;
        bottom: 0;
        left: 0;
        font-size: 0.17rem;
        box-sizing: border-box;
        font-weight: 500;
        line-height: 0.52rem;
    }
    .centerText {
      color: #516374;
      font-size: 0.14rem;
    }
    .confirmText {
      color: #ffffff;
      height: 0.52rem;
      line-height: 0.52rem;
      background: #1fadf6;
    }
  }
}
</style>
